export default function IconPlayVideo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 2"
      viewBox="0 0 22 24"
    >
      <path
        d="M1 1v22l20-11L1 1z"
        data-name="Layer 1"
        style={{
          fill: "var(--color-primary)",
          stroke: "#ffefef",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
        }}
      />
    </svg>
  );
}
